import { addMonths, format, differenceInDays } from 'date-fns'
import { DateFormats } from '../../../api/absence/tempTypes/generalprops'

export const calculateDisableAfterDate = (
  fromDate: Date | null,
  disableOnOrAfterMonths?: number
): Date | undefined => {
  if (!fromDate || !disableOnOrAfterMonths) return undefined
  return addMonths(fromDate, disableOnOrAfterMonths)
}

export const calculateDisableBeforeDate = (
  toDate: Date | null,
  disableOnOrAfterMonths?: number
): Date | undefined => {
  if (!toDate || !disableOnOrAfterMonths) return undefined
  return addMonths(toDate, disableOnOrAfterMonths * -1)
}

export const isWeekend = (date: Date): boolean => {
  const day = date.getDay()
  return day === 0 || day === 6
}

export const isDateDisabled = (
  date: Date,
  disabledDates?: string[]
): boolean => {
  if (!disabledDates) return false
  
  return disabledDates.some(
    disabledDate =>
      format(date, DateFormats.Date) === 
      format(new Date(disabledDate), DateFormats.Date)
  )
}

export const isRangeExceedsMax = (
  startDate: Date | null,
  endDate: Date | null,
  maxRangeDays?: number
): boolean => {
  if (!maxRangeDays || !startDate || !endDate) {
    return false
  }
  
  const rangeDays = differenceInDays(endDate, startDate) + 1
  return rangeDays > maxRangeDays
}

export const isInvalidRange = (
  startDate: Date | null,
  endDate: Date | null
): boolean => !!(startDate && endDate && startDate > endDate)

export const shouldDisableDate = (
  date: Date,
  {
    weekendOnly,
    disabledDates
  }: {
    weekendOnly: boolean
    disabledDates?: string[]
  }
): boolean => {
  // Check weekend restriction
  if (weekendOnly && !isWeekend(date)) {
    return true
  }

  // Check specific disabled dates
  return isDateDisabled(date, disabledDates)
}